
import {SocialMedia} from './socialMedia';
import {JsonObject, JsonProperty} from 'json2typescript';
import {ExternalLinkConverter} from '../../customJsonConverters/ExternalLinkConverter';
import {ExternalLink} from './externalLink';
// This class is also used to represent a social share via a microsite
@JsonObject('ThirdPartyShare')
export class ThirdPartyShare extends SocialMedia {

    // TODO: Remove all thses if json2Typescript can understand the inheritance ocncept
    @JsonProperty('shareClass',String,true)
    public shareClass = '';

    @JsonProperty('clickArea',String,true)
    public clickArea = '';

    @JsonProperty('configFile',String,true)
    public configFile = '';

    @JsonProperty('link',ExternalLinkConverter)
    public link = new ExternalLink();

    @JsonProperty('image',String,true)
    public image = '';

     constructor() {
       super();
     }

}
